export function isNumber(val: unknown): boolean {
  return val !== undefined && val !== null && !Number.isNaN(Number(val));
}
